import './App.css';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './Pages/LandingPage';
import PageNotFound from './Pages/PageNotFound';
import SignUpPage from "./Pages/SignUpPage";
import ConfirmCodePage from "./Pages/ConfirmCodePage";
import LoginPage from "./Pages/LoginPage";
import DashboardPage from "./Pages/DashboardPage";
import PrivateRoute from "./components/PrivateRoute";
import ClientsPage from "./Pages/ClientsPage";
import ClientDetailsPage from "./Pages/ClientDetailsPage";
import AddInteractionPage from './Pages/AddInteractionPage';
import ScrollToTop from "./components/ScrollToTop";
import InteractionPage from "./Pages/InteractionPage";
import EditInteractionPage from "./Pages/EditInteractionPage";
import ClientHistoryPage from "./Pages/ClientHistoryPage";
import FollowUpsPage from "./Pages/FollowUpsPage";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage";
import ProfileSettingsPage from "./Pages/ProfileSettingsPage";
import AccountDeletedPage from "./Pages/AccountDeletedPage";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import ResetPasswordPage from "./Pages/ResetPasswordPage";
import ChangePasswordPage from "./Pages/ChangePasswordPage";
import SubscriptionSelectPage from "./Pages/SubscriptionSelectPage";
import CheckoutPage from "./Pages/CheckoutPage";
import CheckoutSuccessPage from "./Pages/CheckoutSuccessPage";
import SubscriptionSettingsPage from "./Pages/SubscriptionSettingsPage";
import ChangeSubscriptionPage from "./Pages/ChangeSubscriptionPage";
import ContactInformationPage from "./Pages/ContactInformationPage";
import CalendarPage from "./Pages/CalendarPage";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/confirm" element={<ConfirmCodePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/account-deleted" element={<AccountDeletedPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/confirm/password-reset" element={<ResetPasswordPage />} />
        <Route path="/setup/subscription" element={<SubscriptionSelectPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/contact" element={<ContactInformationPage />} />
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/client/:id" element={<ClientDetailsPage />} />
          <Route path="/interaction/new/:clientId" element={<AddInteractionPage />} />
          <Route path="/interaction/:id" element={<InteractionPage />} />
          <Route path="/interaction/update/:id" element={<EditInteractionPage />} />
          <Route path="/client/history/:clientId" element={<ClientHistoryPage />} />
          <Route path="/follow-ups" element={<FollowUpsPage />} />
          <Route path="/settings/profile" element={<ProfileSettingsPage />} />
          <Route path="/settings/subscription" element={<SubscriptionSettingsPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="/upgrade/subscription" element={<ChangeSubscriptionPage />} />
          <Route path="/calendar" element={<CalendarPage />}/>
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
